export default {
  "anime": {
    "title": "在线动画",
    "categories": [
      "全部",
      "无广告",
      "国产动画"
    ],
    "sites": [
     {
        "name": "哔咪哔咪",
        "url": "http://m.dodoge.me/",
        "category": "all,国产动画",
        "description": "清晰度1080p，部分国产有，旧番资源不太稳定",
        "icon": "/item_icons/m_dodoge_me.webp"
      },
      {
        "name": "稀饭动漫",
        "url": "https://xifan.moe/",
        "category": "all",
        "description": "主打新番，清晰度1080p，400M+大，更新较快，无国产动画",
        "icon": "/item_icons/dick_xfani_com.webp"
      },
      {
        "name": "GriGri爱动漫",
        "url": "https://bgm.girigirilove.com/",
        "category": "all",
        "description": "资源搬字幕组的，300M+大小，有简繁双线路，无国产",
        "icon": "/item_icons/anime_girigirilove_com.webp"
      },
            {
        "name": "萌番&嗷呜动漫",
        "url": "https://www.aowu.tv/",
        "category": "all",
        "description": "高清日番",
        "icon": "/item_icons/www_moefun_net.webp"
      },
      {
        "name": "打驴动漫",
        "url": "https://www.dalvdm.cc/",
        "category": "all,国产动画,无广告",
        "description": "高清无广告，更新较快",
        "icon": "/item_icons/www_dqsj_top.webp"
      },
      {
        "name": "ANi-需翻",
        "url": "https://openani.an-i.workers.dev/",
        "category": "all,无广告",
        "description": "繁体，搬运动画疯1080P，同步更新，提供在线/下载，需要代理",
        "icon": "/item_icons/aniopen_an-i_workers_dev.webp"
      },

      {
        "name": "次元城动漫",
        "url": "https://www.cyc-anime.net/",
        "category": "all",
        "description": "清晰度较好，有app，无国产",
        "icon": "/item_icons/www_cycity_pro.webp"
      },
      {
        "name": "酱紫社动漫",
        "url": "https://www.jzsdm1.com/",
        "category": "all,无广告",
        "description": "高清无广告",
        "icon": "/item_icons/www.jzsdm1.com.webp"
      },
      // {
      //   "name": "趣动漫",
      //   "url": "https://www.qdm.plus/",
      //   "category": "国产动画,无广告",
      //   "description": "线路换的快，中日都有，老番挺多",
      //   "icon": "/item_icons/www_qdm66_com.webp"
      // },
      // {
      //   "name": "NT动漫",
      //   "url": "http://www.ntdm9.com/",
      //   "category": "all,国产动画,无广告",
      //   "description": "新番清晰度高，有国产，旧番跟其他网站一样码率低",
      //   "icon": "/item_icons/www_ntdm9_com.webp"
      // },
      {
        "name": "路漫漫",
        "url": "https://i.qg50.com/",
        "category": "国产动画,无广告",
        "description": "清晰度中等，更新较快，中日都有",
        "icon": "/item_icons/www.lmm62.com.webp"
      },
      {
        "name": "樱之空动漫",
        "url": "https://www.skr3.cc/",
        "category": "all,国产动画",
        "description": "线路多，分类多，清晰度一般",
        "icon": "/item_icons/www_skr3_cc.webp"
      },
      {
        "name": "番薯动漫",
        "url": "https://ads-static.xhscdn.com/crm/104101sg314kceo3tg206crb9bg0000001c1h4j1m7si14",
        "category": "all",
        "description": "只有日番，新番清晰度高，更新较快",
        "icon": "/item_icons/www_fsdm02_com.webp"
      },
      {
        "name": "AGE动漫",
        "url": "https://www.agedm.org/",
        "category": "all,无广告,国产动画",
        "description": "视频100M+大小，低清，更新快",
        "icon": "/item_icons/www_agedm_org.webp"
      },
      {
        "name": "Anime1",
        "url": "https://anime1.me/",
        "category": "all",
        "description": "繁体、搬运高清的字幕组以及巴哈源",
        "icon": "/item_icons/anime1_me.webp"
      },
      {
        "name": "9anime",
        "url": "https://9animetv.to/home",
        "category": "all,国产动画",
        "description": "英字，搬运国产，日本动漫",
        "icon": "/item_icons/www1_aniwave_ch.webp"
      },
      {
        "name": "吐槽弹幕网",
        "url": "https://www.tucao.fun/",
        "category": "all",
        "description": "创建于2011年",
        "icon": "/item_icons/www.tucao.fun.webp"
      },
      {
        "name": "佩可爱动漫",
        "url": "https://peko.love",
        "category": "all",
        "description": "高清日番，提供高质量、稳定且大陆海外均可用的在线番剧",
        "icon": "/item_icons/peko.love.webp"
      },
    ]
  },
  "down": {
    "title": "动画下载、字幕下载",
    "categories": [
      "全部",
      "磁力",
      "网盘",
      "字幕"
    ],
    "sites": [
      {
        "name": "动漫花园",
        "url": "https://share.dmhy.org/",
        "category": "磁力",
        "description": "字幕组发布地，需要开代理进入",
        "icon": "/item_icons/share_dmhy_org.webp"
      },
      {
        "name": "NYAA",
        "url": "https://nyaa.si/",
        "category": "磁力",
        "description": "国外ACG的BT站，生肉比较多，需要代理",
        "icon": "/item_icons/nyaa_si.webp"
      },
      {
        "name": "VCB-S",
        "url": "https://vcb-s.com/",
        "category": "磁力",
        "description": "一个动画压制组发布站",
        "icon": "/item_icons/vcb-s_com.webp"
      },
      {
        "name": "NYAA-免翻",
        "url": "https://nyaa.land/",
        "category": "磁力",
        "description": "免番",
        "icon": "/item_icons/nyaa_land.webp"
      },
      {
        "name": "蜜柑计划-免翻",
        "url": "https://mikanime.tv/",
        "category": "磁力",
        "description": "界面好看，新番更新分类做得好，可RSS订阅下载BT",
        "icon": "/item_icons/mikanime_tv.webp"
      },
      {
        "name": "末日动漫",
        "url": "https://share.acgnx.se/",
        "category": "磁力",
        "description": "BT发布站，有分类搜索",
        "icon": "/item_icons/share_acgnx_se.webp"
      },
      {
        "name": "萌番组",
        "url": "https://bangumi.moe/",
        "category": "磁力",
        "description": "需代理，有tag搜索，UI好看，部分字幕组BT首发地",
        "squareColor": ""
      },
      {
        "name": "ACG.RIP",
        "url": "https://acg.rip/",
        "category": "磁力",
        "description": "ACGN种子发布站，需代理，无tag搜索",
        "icon": "/item_icons/acg_rip.webp"
      },
      {
        "name": "Anime Garden",
        "url": "https://garden.breadio.wiki/",
        "category": "磁力",
        "description": "動漫花園資源網第三方镜像站",
        "icon": "/item_icons/garden.breadio.wiki.webp"
      },
      // {
      //   "name": "怡萱动漫",
      //   "url": "https://www.iyxdm.org/",
      //   "category": "网盘",
      //   "description": "动画百度网盘资源，点击开启虫洞然后刷新页面",
      //   "icon": "/item_icons/www_iyxdm_org.webp"
      // },
      {
        "name": "次元狗",
        "url": "https://www.acgndog.com//",
        "category": "网盘",
        "description": "资源为百度/阿里网盘，主打动画；漫画小说也有",
        "icon": "/item_icons/www_acgndog_com.webp"
      },
      {
        "name": "二次元虫洞",
        "url": "http://www.2cycd.com/",
        "category": "网盘",
        "description": "有旧番资源，音乐，网盘/磁力",
        "icon": "/item_icons/www_2cycd_com.webp"
      },
      {
        "name": "爱弹幕",
        "url": "https://idanmu.net",
        "category": "磁力",
        "description": "爱弹幕(iDanMu.net)是一家ACG二次元资源互动分享平台，让每一个用户都能从中分享快乐。iDanMu 発射！( ˘•ω•˘ )ง ====⊱ 節操⋛粉碎⋚",
        "icon": "/item_icons/idanmu.net.webp"
      },
      {
        "name": "Anime字幕论坛",
        "url": "https://bbs.acgrip.com/",
        "category": "字幕",
        "description": "动画字幕,vcb的论坛",
        "icon": "/item_icons/bbs_acgrip_com.webp"
      },
      {
        "name": "天雪论坛",
        "url": "https://skyeysnow.com/",
        "category": "字幕",
        "description": "动画资源论坛，找字幕挺好使",
        "icon": "/item_icons/skyeysnow_com.webp"
      },
      {
        "name": "kitsunekko",
        "url": "https://kitsunekko.net/",
        "category": "字幕",
        "description": "字幕下载，主要是日文字幕",
        "icon": "/item_icons/kitsunekko.net.webp"
      }
    ]
  },
  "comic": {
    "title": "在线漫画、下载",
    "categories": [
      "全部",
      "在线漫画",
      "漫画下载"
    ],
    "sites": [
      {
        "name": "拷贝漫画",
        "url": "https://www.mangacopy.com/",
        "category": "在线漫画",
        "description": "目前比较全的日漫、韩漫、美漫也有",
        "icon": "/item_icons/www_mangacopy_com.webp"
      },
      {
        "name": "Komiic漫畫",
        "url": "https://komiic.com/",
        "category": "在线漫画",
        "description": "无广告，高清日漫、韩漫，浏览有额度限制",
        "icon": "/item_icons/komiic_com.webp"
      },

      {
        "name": "漫画柜",
        "url": "https://www.manhuagui.com/",
        "category": "在线漫画",
        "description": "需要开代理，资源很全,漫画没有水印",
        "icon": "/item_icons/tw_manhuagui_com.webp"
      },
      {
        "name": "Neko Project",
        "url": "https://nky.my/",
        "category": "在线漫画",
        "description": "无广告，在线漫画、轻小说、动漫、音声",
        "icon": "/item_icons/nekoyo.co.webp"
      },
      {
        "name": "Mangabz",
        "url": "https://www.mangabz.com/",
        "category": "在线漫画",
        "description": "在线日本漫画",
        "icon": "/item_icons/www_mangabz_com.webp"
      },
      {
        "name": "包子漫画",
        "url": "https://www.baozimh.com/",
        "category": "在线漫画",
        "description": "国、日、韩漫都有，水印多",
        "icon": "/item_icons/www_baozimh_com.webp"
      },
      {
        "name": "G站漫画",
        "url": "https://nav.telltome.net/",
        "category": "在线漫画",
        "description": "有韩、国漫，广告多",
        "icon": "/item_icons/nav_telltome_net.webp"
      },
      {
        "name": "漫画160",
        "url": "https://www.mh160.cc/",
        "category": "在线漫画",
        "description": "在线漫画",
        "squareColor": ""
      },
      {
        "name": "次元狗-漫画",
        "url": "https://www.acgndog.com/category/rec-comic",
        "category": "漫画下载",
        "description": "漫画下载",
        "icon": "/item_icons/www_acgndog_com.webp"
      },
      {
        "name": "Kindle漫画",
        "url": "https://www.comicbackup.com/",
        "category": "漫画下载",
        "description": "漫画下载",
        "icon": "/item_icons/www_comicbackup_com.webp"
      },
      {
        "name": "Kox漫画下载",
        "url": "https://kox.moe/",
        "category": "漫画下载",
        "description": "资源较全，每月免费额度/付费下载漫画",
        "icon": "/item_icons/kox_moe.webp"
      },
      {
        "name": "补档冰室",
        "url": "https://www.manhuabudangbbs.com/",
        "category": "漫画下载",
        "description": "漫画下载论坛，需签到",
        "icon": "/item_icons/www_manhuabudangbbs_com.webp"
      },
      {
        "name": "Zero搬运网",
        "url": "https://zerobyw.github.io/",
        "category": "漫画下载",
        "description": "下载工具, https://github.com/Bear-biscuit/Zero_download",
        "icon": "/item_icons/www.zerobywtar.com.webp"
      },
      {
        "name": "rawkuma",
        "url": "https://rawkuma.net/",
        "category": "在线漫画,漫画下载",
        "description": "漫画生肉，可在线或下载",
        "icon": "/item_icons/rawkuma.net.webp"
      }
    ]
  },
  "game": {
    "title": "GALGAME下载",
    "categories": [
      "全部",
      "本体",
      "补丁or攻略",
      "模拟器"
    ],
    "sites": [
      {
        "name": "Touchgal",
        "url": "https://www.touchgal.top/",
        "category": "本体",
        "description": "汉化GAL下载，改新域名top",
        "icon": "/item_icons/www_touchgal_org.webp"
      },
      {
        "name": "失落小站",
        "url": "https://www.shinnku.com/",
        "category": "all",
        "description": "本体",
        "icon": "/item_icons/www_shinnku_com.webp"
      },
      {
        "name": "忧郁的萝莉",
        "url": "https://www.ttloli.com",
        "category": "本体",
        "description": "老牌GAL站，不知道还能活多久",
        "icon": "/item_icons/www_ttloli_com.webp"
      },
      {
        "name": "初音的青葱",
        "url": "https://yngal.com/",
        "category": "黄油",
        "description": "GAL下载，需要签到",
        "icon": "/item_icons/yngal_com.webp"
      },
      {
        "name": "樱花资源网",
        "url": "https://www.acgyhw.com/",
        "category": "本体",
        "description": "GAL下载",
        "icon": "/item_icons/acgyh.com.webp"
      },

      {
        "name": "GALXP分享你的XP",
        "url": "https://www.galdl.com/",
        "category": "all",
        "description": "本体",
        "icon": "/item_icons/www_galxp_com.webp"
      },
      {
        "name": "量子ACG ",
        "url": "https://lzacg.org/",
        "category": "all",
        "description": "GAL下载",
        "icon": "/item_icons/www_lzacg_net.webp"
      },
      {
        "name": "绅士天堂",
        "url": "https://www.gogalgame.com/",
        "category": "all",
        "description": "GAL下载",
        "icon": "/item_icons/www_gogalgame_com.webp"
      },
      {
        "name": "绯月论坛",
        "url": "https://bbs.kfpromax.com/login.php",
        "category": "补丁or攻略",
        "description": "galgame论坛",
        "icon": "/item_icons/bbs_kfpromax_com.webp"
      },
      {
        "name": "2DFan",
        "url": "https://2dfan.com/",
        "category": "补丁or攻略",
        "description": "补丁/CG/攻略",
        "icon": "/item_icons/2dfan_com.webp"
      },
      {
        "name": "GGBases",
        "url": "https://ggbases.dlgal.com/",
        "category": "本体,补丁or攻略",
        "description": "生肉，补丁/CG/攻略",
        "icon": "/item_icons/ggbases.dlgal.com.webp"
      },
      {
        "name": "御爱同萌",
        "url": "https://www.ai2.moe/",
        "category": "本体,补丁or攻略",
        "description": "资源论坛、翻译补丁",
        "icon": "/item_icons/www.ai2.moe.webp"
      },
      {
        "name": "鲲 Galgame",
        "url": "https://www.moyu.moe/",
        "category": "补丁or攻略",
        "description": "开源 Galgame 补丁资源下载站",
        "icon": "/item_icons/www.moyu.moe.webp"
      },
      {
        "name": "梓澪の妙妙屋",
        "url": "https://zi0.cc/",
        "category": "本体,模拟器",
        "description": "PC/安卓的GAL、黄油下载，用idm下载较快",
        "icon": "/item_icons/zi0_cc.webp"
      },
      {
        "name": "LSP福利社",
        "url": "https://lsplsp.com/",
        "category": "本体",
        "description": "全能社区，主打RPG+SLG汉化",
        "icon": "/item_icons/lspfls.xyz.jpg"
      },
      {
        "name": "单机游戏下载-koyso",
        "url": "https://koyso.com/",
        "category": "单机游戏",
        "description": "建议用迅雷下载",
        "icon": "/item_icons/koyso_com.webp"
      },
      {
        "name": "玖黎ACG",
        "url": "https://jiuliacg.top/",
        "category": "本体",
        "description": "一个免费分享Gal，Cos，Asmr的网站Ciallo～",
        "icon": "/item_icons/feiyuwan.top.webp"
      },
      {
        "name": "宮代千紗",
        "url": "https://gdqs.org/",
        "category": "本体",
        "description": "一个免费分享Gal，Cos图的网站",
        "icon": "/item_icons/gdqs.org.webp"
      },
      {
        "name": "Steam官网",
        "url": "https://store.steampowered.com/",
        "category": "本体",
        "description": "steam官方网址",
        "icon": "/item_icons/store.steampowered.com.webp"
      }
    ]
  },
   "novel": {
    "title": "在线轻小说、网文下载",
    "categories": [
      "全部",
      "在线轻小说",
      "小说下载"
    ],
    "sites": [
      {
        "name": "轻小说文库",
        "url": "https://www.wenku8.net/index.php",
        "category": "在线轻小说,小说下载",
        "description": "目前开放注册了，需要登录，有日轻在线/下载",
        "icon": "/item_icons/www_wenku8_net.webp"
      },
      {
        "name": "哔哩轻小说",
        "url": "https://www.bilinovel.com/",
        "category": "在线轻小说",
        "description": "在线轻小说",
        "icon": "/item_icons/www_linovelib_com.webp"
      },
      {
        "name": "轻之国度",
        "url": "https://www.lightnovel.fun/",
        "category": "在线轻小说",
        "description": "目前可以正常注册",
        "icon": "/item_icons/www_lightnovel_us.webp"
      },
      {
        "name": "神凑轻小说",
        "url": "http://www.shencou.com/",
        "category": "在线轻小说",
        "description": "在线轻小说",
        "icon": "/item_icons/www_shencou_com.webp"
      },
      {
        "name": "Neko Project",
        "url": "https://nekoyo.co/index?category=novel",
        "category": "在线轻小说",
        "description": "无广告，在线漫画、轻小说、动漫、音声",
        "icon": "/item_icons/nekoyo.co.webp"
      },
      {
        "name": "Z-Library",
        "url": "https://z-library.sk/",
        "category": "小说下载",
        "description": "需要代理，海量电子书下载",
        "icon": "/item_icons/zlibrary.webp"
      },
      {
        "name": "魔笔轻小说",
        "url": "https://mobinovels.com/",
        "category": "小说下载",
        "description": "轻小说EPUB下载，密码看右上公告6195",
        "icon": "/item_icons/mobinovels_com.webp"
      },
      {
        "name": "安娜的档案",
        "url": "https://zh.annas-archive.li/",
        "category": "小说下载",
        "description": "需代理，旧域名被hold，海量书籍资料以及Spotify音乐库，数据抓取并开源了Z-Lib、SciDB、读秀等",
        "icon": "/item_icons/zh_annas-archive_org.webp"
      },
      {
        "name": "搜书吧",
        "url": "http://www.soushu2025.com/",
        "category": "小说下载",
        "description": "含🔞，丰富的小说下载论坛",
        "icon": "/item_icons/www.soushu2025.com.webp"
      },
      {
        "name": "ESJ Zone",
        "url": "https://www.esjzone.one/",
        "category": "在线轻小说",
        "description": "含🔞，论坛形式最好注册",
        "icon": "/item_icons/www.esjzone.one.webp"
      },
      {
        "name": "幻梦轻小说",
        "url": "https://www.huanmengacg.com/",
        "category": "在线轻小说",
        "description": "免费日本动漫/SF轻小说在线阅读，部分书籍被下架了，公告跳转贴吧有部分书网盘下载",
        "squareColor": ""
      },
      {
        "name": "真白萌 ",
        "url": "https://masiro.me/admin",
        "category": "在线轻小说",
        "description": "需要注册",
        "icon": "/item_icons/masiro_me.webp"
      },
      {
        "name": "轻小说机翻",
        "url": "https://books.fishhawk.top/",
        "category": "小说下载",
        "description": "提供轻小说下载与AI翻译，若无汉化是个不错的选择",
        "icon": "/item_icons/books_fishhawk_top.webp"
      },
      {
        "name": "轻书架",
        "url": "https://www.lightnovel.love",
        "category": "在线轻小说",
        "description": "在线日轻，有插图，需邀请码，有TG群",
        "icon": "/item_icons/www_lightnovel_love.svg"
      },
      {
        "name": "宝书网",
        "url": "https://m.baoshu7.com/",
        "category": "小说下载",
        "description": "网文下载",
        "icon": "/item_icons/m_baoshu7_com.webp"
      }
    ]
  },
  "movie": {
    "title": "在线影视、影片下载",
    "categories": [
      "全部",
      "在线观看",
      "下载",
      "字幕"
    ],
    "sites": [
      {
        "name": "播剧网",
        "url": "https://www.ysxq.cc/",
        "category": "在线观看",
        "description": "高清无广告，电影电视剧",
        "icon": "/item_icons/www.ysxq.cc.webp"
      },
      {
        "name": "BTNULL",
        "url": "https://www.xn--ykq321c.com/",
        "category": "在线观看,下载",
        "description": "需代理，下片使用，提供磁力/在线/网盘，多种清晰度选择，需登录",
        "icon": "/item_icons/www_gying_net.webp"
      },
      {
        "name": "可可影视",
        "url": "https://dl.kkys03.com/",
        "category": "在线观看",
        "description": "有广、在线播放，资源多更新快，清晰度一般",
        "icon": "/item_icons/dl_kkys03_com.webp"
      },
      {
        "name": "皮皮妖",
        "url": "https://www.pipiyao.vip/",
        "category": "在线观看",
        "description": "在线播放",
        "icon": "/item_icons/www.pipiyao.vip.webp"
      },
      {
        "name": "电影港",
        "url": "https://www.dygangs.net/",
        "category": "下载",
        "description": "主下载电影用，有电影、动画、电视剧，提供磁力或在线",
        "icon": "/item_icons/www.dygangs.net.webp"
      },
      {
        "name": "爱看机器人",
        "url": "https://www.ikanbot.com/",
        "category": "在线观看",
        "description": "有广告，多线路，清晰度一般",
        "icon": "/item_icons/www_ikanbot_com.webp"
      },
      {
        "name": "人人电影网",
        "url": "https://www.rrdynb.com/index.html",
        "category": "下载",
        "description": "影视资源,百度云盘,阿里网盘下载",
        "icon": "/item_icons/www.rrdynb.com.webp"
      },
      {
        "name": "LIBVIO",
        "url": "https://www.libvio.site/",
        "category": "在线观看,下载",
        "description": "在线/网盘，请勿相信广告",
        "icon": "/item_icons/libvio_cc.webp"
      },
      {
        "name": "日剧跑",
        "url": "https://www.rijupao.com/",
        "category": "下载",
        "description": "日剧资源分享，网盘",
        "icon": "/item_icons/www_rijupao_com.webp"
      },
      {
        "name": "看片狂人 ",
        "url": "https://www.kpkuang.fun/",
        "category": "在线观看,下载",
        "description": "多源搜索",
        "icon": "/item_icons/www_kpkuang_fun.webp"
      },
      {
        "name": "电影天堂",
        "url": "https://www.dytt8899.com/",
        "category": "下载",
        "description": "电影下载",
        "icon": "/item_icons/www_dy2018_com.webp"
      },
      {
        "name": "美剧天堂",
        "url": "https://www.meijutt.org/",
        "category": "下载",
        "description": "美剧下载",
        "icon": "/item_icons/www_meijutt_tw.webp"
      },
      {
        "name": "SubHD-下载字幕",
        "url": "https://subhd.tv/",
        "category": "字幕",
        "description": "字幕下载",
        "icon": "/item_icons/subhd_tv.webp"
      },
      {
        "name": "射手网（伪）",
        "url": "https://assrt.net/",
        "category": "字幕",
        "description": "字幕下载",
        "icon": "/item_icons/assrt_net.webp"
      }
    ]
  },
    "ai": {
    "title": "AI工具",
    "categories": [
      "全部",
      "文本",
      "图片"
    ],
    "sites": [
      {
        "name": "Ai女友 (在线畅玩)",
        "url": "http://coverstation.xyz?ref_id=8484cc1f-624c-4713-a73c-b87cfa51bd93",
        "category": "文本",
        "description": "Ai女友，全球最大中文AIGC平台，专为终端用户使用尖端AI模型打造更先进的AIGC创作与互动叙事和工作效率工具。Ai女友拥有宏大的卡片集即多样化的角色与场景库，集齐Ai沉浸式角色扮演、私密Ai聊天、定制化互动叙事、情感交流、效率工具。",
        "icon": "/item_icons/newplace.shop.webp"
      },
      {
        "name": "ACEMusic",
        "url": "https://acemusic.ai/",
        "category": "all",
        "description": "免费AI音乐生成，ai歌曲社区，可下载，可用api",
        "icon": "/item_icons/acemusic.ai.svg"
      },
      {
        "name": "Google Ai Studio",
        "url": "https://aistudio.google.com/app/prompts/new_chat",
        "category": "文本,图片",
        "description": "需代理，谷歌AI，可用Nano Banana生图，以及每日免费额度Gemini对话",
        "icon": "/item_icons/aistudio.google.com.webp"
      },
      {
        "name": "Flow",
        "url": "https://labs.google/flow/about",
        "category": "图片",
        "description": "生成图片或视频，每日免费NaNo Banana Pro额度",
        "squareColor": ""
      },
      {
        "name": "Felo",
        "url": "https://felo.ai/search",
        "category": "文本",
        "description": "AI搜索引擎，搜索的内容质量很棒，挺强大的",
        "icon": "/item_icons/felo_ai.webp"
      },
      {
        "name": "DeepSeek深度求索",
        "url": "https://www.deepseek.com/",
        "category": "文本",
        "description": "国产顶级AI",
        "icon": "/item_icons/www.deepseek.com.webp"
      },
      {
        "name": "Real-ESRGAN",
        "url": "https://github.com/xinntao/Real-ESRGAN",
        "category": "图片",
        "description": "Al图像超分辨率/视频修复",
        "icon": "/item_icons/github_com.webp"
      },
      {
        "name": "video2x",
        "url": "https://github.com/k4yt3x/video2x",
        "category": "图片",
        "description": "视频超分辨率和插帧",
        "icon": "/item_icons/github_com.webp"
      },
      {
        "name": "哩布哩布AI",
        "url": "https://www.liblib.art/",
        "category": "图片",
        "description": "免费在线AI绘画",
        "icon": "/item_icons/www_liblib_art.webp"
      },
      {
        "name": "Bigjpg-图片无损放大",
        "url": "https://bigjpg.com/zh",
        "category": "图片",
        "description": "AI人工智能图片放大",
        "icon": "/item_icons/bigjpg_com.webp"
      },
      {
        "name": "图片去除背景-免费AI抠图",
        "url": "https://www.koukoutu.com/removebgtool/all",
        "category": "图片",
        "description": "AI一键去背景",
        "icon": "/item_icons/www.koukoutu.com.webp"
      },
      {
        "name": "AI 图片水印去除器",
        "url": "https://www.watermarkremover.io/zh/upload",
        "category": "图片",
        "description": "免费在线擦除与标志清除工具",
        "icon": "/item_icons/www.watermarkremover.io.webp"
      },
      {
        "name": "AI图鉴定",
        "url": "https://hivemoderation.com/ai-generated-content-detection/?demo=image",
        "category": "图片",
        "description": "判断是否是AI图片",
        "icon": "/item_icons/hivemoderation_com.webp"
      }
    ]
  },
  "proxy": {
    "title": "代理加速、魔法上网",
    "categories": ["全部","不限时","APP"],
    "sites": [

      {
        "name": "赔钱机场",
        "url": "https://dash.pqjc.site/#/register",
        "category": "all,不限时",
        "description": "多个国家、地区节点可供选择使用，高性价比机场，包含0.1倍率低扣费福利下载节点，稳定解锁奈菲、迪士尼、TikTok、ChatGPT，其余流媒体或AI请自测，随缘解锁",
        "icon": "/item_icons/xn--mes358aby2apfg.site.webp"
      },
      {
        "name": "LinkCube",
        "url": "https://linkcube.org/aff.php?aff=3383",
        "category": "all",
        "description": "带aff，性价比专线机场，稳定快速，解锁AI，Net­flix 等主流媒体资源。包含台湾、日本、美国等ip。",
        "icon": "/item_icons/linkcube.webp"
      },
      {
        "name": "iKuuu",
        "url": "https://ikuuu.org/",
        "category": "all",
        "description": "每月免费50G，月初重置，免费节点如果用不了就是被墙了，属正常情况。免费套餐不稳，无AFF勿滥用",
        "icon": "/item_icons/ikuuu.org.webp"
      },
      {
        "name": "Clash Meta Android",
        "url": "https://github.com/MetaCubeX/ClashMetaForAndroid/releases",
        "category": "all,APP",
        "description": "Clash Meta for Android 是一个功能强大、高度可定制的安卓平台网络代理客户端。通过Clash Meta内核和插件系统，它可以满足各种复杂的代理需求。",
        "icon": "/item_icons/clashmeta.webp"
      },
      {
        "name": "v2rayNG Android",
        "url": "https://github.com/2dust/v2rayNG/releases",
        "category": "all,APP",
        "description": "V2RayNG 是目前安卓平台上功能最全面、用户最多的代理客户端之一，开源免费，支持多种协议。",
        "icon": "/item_icons/v2rayN.webp"
      },
      {
        "name": "Sparkle PC",
        "url": "https://github.com/xishang0128/sparkle/releases",
        "category": "all,APP",
        "description": "Sparkle 是一个PC代理客户端。支持Windows、Linux、macOS。多种配色主题可选，内置Mihomo内核，强大的覆写功能，任意修订配置文件，集成Sub-Store，轻松管理订阅。",
        "icon": "/item_icons/clashmeta.webp"
      },
      {
        "name": "v2rayN PC",
        "url": "https://github.com/2dust/v2rayN/releases",
        "category": "all,APP",
        "description": "V2RayN 是一个Windows平台下流行的代理客户端软件。V2RayN智能化的路由分流和便捷的系统代理切换，使得在Windows上配置和使用V2Ray变得更加简单。",
        "icon": "/item_icons/v2rayN.webp"
      },
    ]
  },
  "music": {
    "title": "二次元音乐、ASMR资源",
    "categories": [
      "全部",
      "音乐",
      "ASMR"
    ],
    "sites": [
      {
        "name": "GD音乐台",
        "url": "https://music.gdstudio.org/",
        "category": "音乐",
        "description": "全网歌曲，在线听/下载",
        "icon": "/item_icons/music.gdstudio.xyz.webp"
      },
      {
        "name": "天使动漫论坛",
        "url": "https://www.tsdm39.com/forum.php",
        "category": "音乐",
        "description": "老牌网盘资源站，主打动画/音乐，需要一定权限",
        "icon": "/item_icons/www_tsdm39_com.webp"
      },
      {
        "name": "ACG漫音社",
        "url": "https://www.acgjc.com/",
        "category": "音乐",
        "description": "分享二次元高品质音乐,网盘资源",
        "icon": "/item_icons/www_acgjc_com.webp"
      },
      {
        "name": "HiFiTi",
        "url": "https://www.hifiti.com/",
        "category": "音乐",
        "description": "HiFiNi已关站，现在是HiFiTi哒",
        "icon": "/item_icons/www_hifini_com.webp"
      },
      {
        "name": "MikuDB",
        "url": "http://mikudb.moe/",
        "category": "音乐",
        "description": "v家专属，网盘资源",
        "icon": "/item_icons/mikudb_moe.webp"
      },
      {
        "name": "Hcs64",
        "url": "https://vgm.hcs64.com/",
        "category": "音乐",
        "description": "主机游戏音乐下载",
        "icon": "/item_icons/vgm_hcs64_com.webp"
      },
      {
        "name": "起名费劲吧",
        "url": "https://tieba.baidu.com/f?kw=%E8%B5%B7%E5%90%8D%E8%B4%B9%E5%8A%B2&ie=utf-8",
        "category": "音乐",
        "description": "ACG音乐资源贴吧，网盘资源",
        "icon": "/item_icons/tieba_baidu_com.webp"
      },
      {
        "name": "ASMR基佬中心",
        "url": "https://www.asmrgay.com/",
        "category": "ASMR",
        "description": "🔞，ASMR网盘资源",
        "icon": "/item_icons/www_asmrgay_com.webp"
      },
      {
        "name": "ASMR.ONE",
        "url": "https://as.mr/",
        "category": "ASMR",
        "description": "需代理，🔞，有标签分类，在线播放/下载",
        "icon": "/item_icons/as.mr.webp"
      },
      {
        "name": "japaneseasmr",
        "url": "https://japaneseasmr.com/",
        "category": "ASMR",
        "description": "需代理，🔞，有分级，在线/网盘",
        "icon": "/item_icons/japaneseasmr_com.webp"
      },
      {
        "name": "hentaiasmr",
        "url": "https://www.hentaiasmr.moe/",
        "category": "ASMR",
        "description": "需代理，🔞，有语言分类，在线/下载",
        "icon": "/item_icons/www_hentaiasmr_moe.webp"
      },
      {
        "name": "koe-koe",
        "url": "https://koe-koe.com/",
        "category": "ASMR",
        "description": "需代理，🔞,有分级，在线播放/下载",
        "icon": "/item_icons/koe-koe_com.webp"
      }
    ]
  },
  "pic": {
    "title": "壁纸、插画、COS图",
    "categories": [
      "全部",
      "壁纸",
      "插画",
      "COS图"
    ],
    "sites": [
      {
        "name": "次世代二次元涩图",
        "url": "https://nekon.app/",
        "category": "壁纸,插画",
        "description": "有P站、推图,有AI搜图,以图搜图功能,海外ip解锁🔞",
        "icon": "/item_icons/nekon_app.webp"
      },
      {
        "name": "Pixiv|P站",
        "url": "https://www.pixiv.net/",
        "category": "插画",
        "description": "需代理，二次元插画网站，上面有各种画师的作品，设置可开🔞",
        "icon": "/item_icons/www_pixiv_net.webp"
      },
      {
        "name": "哲风壁纸",
        "url": "https://haowallpaper.com/",
        "category": "壁纸",
        "description": "免费4K高清壁纸，电脑、手机背景图片，还可制作头像",
        "icon": "/item_icons/haowallpaper.com.webp"
      },
      {
        "name": "Manyacg-萝莉图",
        "url": "https://manyacg.top/",
        "category": "插画",
        "description": "大部分是萝莉图，二次元图片分享,可按标签搜索",
        "icon": "/item_icons/manyacg.top.webp"
      },
      {
        "name": "萌哩-萝莉图",
        "url": "https://www.moely.link/",
        "category": "插画",
        "description": "大部分是萝莉图，二次元图片分享,可按标签筛选",
        "icon": "/item_icons/www.moely.link.webp"
      },
      {
        "name": "Wallhaven",
        "url": "https://wallhaven.cc/",
        "category": "壁纸",
        "description": "需代理，高质量、高分辨率的电脑壁纸，二次元图较多,可按标签、分辨率搜索",
        "icon": "/item_icons/wallhaven_cc.webp"
      },
      {
        "name": "萌萝社",
        "url": "https://www.042l.com/",
        "category": "COS图",
        "description": "萝莉写真，cos图，免费高清图片",
        "icon": "/item_icons/042l.com.webp"
      },
      {
        "name": "anime-pictures",
        "url": "https://anime-pictures.net/posts?page=0&lang=zh-cn",
        "category": "壁纸",
        "description": "高分辨率，手机尺寸较多的二次元壁纸网,可按标签搜索",
        "icon": "/item_icons/anime-pictures_net.webp"
      },
      {
        "name": "zerochan",
        "url": "https://www.zerochan.net/",
        "category": "插画",
        "description": "一个专注于动漫角色的图片网站",
        "icon": "/item_icons/www_zerochan_net.webp"
      },
      {
        "name": "safebooru",
        "url": "https://safebooru.org/index.php?page=post&s=list&tags=all",
        "category": "插画",
        "description": "Safebooru是一个动画和漫画图片搜索引擎，图片每小时更新一次。",
        "icon": "/item_icons/safebooru.org.webp"
      },
      {
        "name": "惜染图库",
        "url": "https://hefollo.com/?cos%E5%9B%BE",
        "category": "COS图,壁纸",
        "description": "正常向COS图、写真、手机电脑壁纸、视频",
        "icon": "/item_icons/hefollo_com.webp"
      },
      {
        "name": "次元岛",
        "url": "http://ciyuandao.com/",
        "category": "COS图",
        "description": "在线COS美图",
        "icon": "/item_icons/ciyuandao.com.webp"
      },
      {
        "name": "Gallery Epic",
        "url": "https://galleryepic.top/",
        "category": "COS图",
        "description": "🔞，COSPLAY图，尺度较大，可能要代理",
        "icon": "/item_icons/galleryepic_com.webp"
      },
      {
        "name": "yande.re",
        "url": "https://yande.re/post",
        "category": "插画",
        "description": "🔞需代理，高分辨率，以标签分类为主的二次元插画网",
        "icon": "/item_icons/yande_re.webp"
      }
    ]
  },
  "trace": {
    "title": "截图找出处、台词找出处",
    "categories": [
      "全部",
      "搜动画",
      "搜插画",
      "搜真人",
      "随便搜"
    ],
    "sites": [
      {
        "name": "以图搜动画",
        "url": "https://trace.moe/",
        "category": "搜动画",
        "description": "动画截图找到出处，精确到秒，需整洁截图，准确率高",
        "icon": "/item_icons/trace_moe.webp"
      },
      {
        "name": "搜图酱-以图搜本子",
        "url": "https://soutubot.moe//",
        "category": "all",
        "description": "可识别EXH本子，出处有直达链接，tg的bot很好使",
        "icon": "/item_icons/soutubot_moe.webp"
      },
      {
        "name": "SauceNAO",
        "url": "https://saucenao.com/",
        "category": "搜动画,搜插画",
        "description": "插画比较好使，动、漫画也可，左侧可跳转其他搜图网站",
        "icon": "/item_icons/saucenao_com.webp"
      },
      {
        "name": "谷歌识图",
        "url": "https://images.google.com/imghp?hl=zh-CN&gws_rd=ssl",
        "category": "随便搜",
        "description": "需梯，识图范围广，基本啥都能搜",
        "icon": "/item_icons/images_google_com.webp"
      },
      {
        "name": "AnimeTrace",
        "url": "https://ai.animedb.cn/",
        "category": "搜动画",
        "description": "可识别动画、GAL截图找出处",
        "icon": "/item_icons/ai_animedb_cn.webp"
      },
      {
        "name": "Iqdb",
        "url": "http://www.iqdb.org/",
        "category": "搜插画",
        "description": "多网址搜索，可直接跳转其他网址搜索，便利",
        "icon": "/item_icons/www_iqdb_org.webp"
      },
      {
        "name": "Yandex识图",
        "url": "https://yandex.ru/images/search?redircnt=1534581013.1",
        "category": "随便搜",
        "description": "毛子识图，时效性比谷歌差点，范围感觉更广，需要配合翻译",
        "icon": "/item_icons/yandex_ru.webp"
      },
      {
        "name": "百度识图",
        "url": "https://image.baidu.com/",
        "category": "随便搜",
        "description": "随缘，百度自家数据有的都能搜出来",
        "icon": "/item_icons/image_baidu_com.webp"
      },
      {
        "name": "lenso",
        "url": "https://lenso.ai/zh",
        "category": "搜真人",
        "description": "识图搜脸，搜索结果有显示域名，部分标题，显示全部需付费；根据这些信息找到动漫人物、动作女明星等等",
        "icon": "/item_icons/lenso_ai.webp"
      },
      {
        "name": "X/sList-以图搜颜",
        "url": "https://xslist.org/zh",
        "category": "搜真人",
        "description": "识图搜日本女明星，需要开代理才能访问",
        "icon": "/item_icons/xslist_org.webp"
      },
      {
        "name": "二次元画像详细检索",
        "url": "https://ascii2d.net/",
        "category": "搜插画",
        "description": "准确率低且有图但很多没标出处，差评，gal截图可能比较准",
        "icon": "/item_icons/ascii2d_net.webp"
      },
      {
        "name": "Dialogue",
        "url": "http://dialogue.moe/search",
        "category": "搜动画",
        "description": "找动画台词，可跳转bangumi",
        "icon": "/item_icons/dialogue_moe.webp"
      },
      {
        "name": "AnimeShot ",
        "url": "https://as2.bitinn.net/",
        "category": "搜动画",
        "description": "找动画台词，直达截图",
        "squareColor": ""
      },
      {
        "name": "33台词",
        "url": "https://33.agilestudio.cn/",
        "category": "all",
        "description": "通过台词找电影",
        "icon": "/item_icons/33_agilestudio_cn.webp"
      },
      {
        "name": "QuoDB",
        "url": "https://www.quodb.com/",
        "category": "all",
        "description": "通过英文台词找电影",
        "icon": "/item_icons/www_quodb_com.webp"
      }
    ]
  },
  "ndbt": {
    "title": "网盘资源、磁力搜索",
    "categories": [
      "全部",
      "网盘搜索",
      "磁力搜索"
    ],
    "sites": [

      {
        "name": "资源避难所",
        "url": "https://www.daiguaji.com/",
        "category": "网盘搜索",
        "description": "百度、夸克网盘 影视软件书籍教程等资源分享，需登录",
        "icon": "/item_icons/www.daiguaji.com.webp"
      },
      {
        "name": "夸夸盘搜",
        "url": "https://www.kuakuaso.com/",
        "category": "网盘搜索",
        "description": "免登录、多网盘搜索",
        "icon": "/item_icons/www.kuakuaso.com.webp"
      },
      {
        "name": "雷鲸小站",
        "url": "https://www.leijing.xyz/",
        "category": "网盘搜索",
        "description": "天翼云盘资源站",
        "icon": "/item_icons/www.leijing.xyz.webp"
      },
      {
        "name": "玩偶4K",
        "url": "https://wogg.xxooo.cf/",
        "category": "网盘搜索",
        "description": "动漫、影视云盘资源站，阿里/夸克/UC",
        "icon": "/item_icons/www_wogg_net.webp"
      },
      {
        "name": "rutracker",
        "url": "https://rutracker.net/forum/index.php",
        "category": "磁力搜索",
        "description": "毛子磁力站，资源非常丰富，应有尽有",
        "icon": "/item_icons/rutracker_net.webp"
      },
      {
        "name": "torrentgalaxy",
        "url": "https://torrentgalaxy.one/",
        "category": "磁力搜索",
        "description": "丰富的国外影视磁力站，可用IMDB的ID搜索",
        "icon": "/item_icons/torrentgalaxy_one.webp"
      },
      {
        "name": "BTSearch",
        "url": "https://www.btsearch.love/",
        "category": "磁力搜索",
        "description": "磁力搜",
        "icon": "/item_icons/www_btsearch_love.webp"
      },
      {
        "name": "柠檬磁力",
        "url": "https://lemongb.top/",
        "category": "磁力搜索",
        "description": "磁力搜",
        "icon": "/item_icons/lemongb_top.webp"
      },
      {
        "name": "prowlarr索引页",
        "url": "https://wiki.servarr.com/prowlarr/supported-indexers",
        "category": "all",
        "description": "磁力站聚合",
        "icon": "/item_icons/wiki_servarr_com.webp"
      },
      {
        "name": "老王磁力",
        "url": "https://laowangzo.top/",
        "category": "磁力搜索",
        "description": "磁力搜索",
        "icon": "/item_icons/laowangzo.top.webp"
      },
      {
        "name": "磁力印象",
        "url": "https://magnet.pics/",
        "category": "all",
        "description": "在線查看磁力資源的影片截圖",
        "icon": "/item_icons/beta_magnet_pics.webp"
      }
    ]
  },
  "wiki": {
    "title": "WIKI、评分、类似搜索",
    "categories": [
      "全部",
      "评分排行",
      "番剧搜索"
    ],
    "sites": [
      {
        "name": "Bangumi",
        "url": "https://bgm.tv/",
        "category": "评分排行",
        "description": "ACGN评分/wiki论坛，注册满2-3月可看哩番条目，可以用来找番",
        "icon": "/item_icons/bgm_tv.webp"
      },
      {
        "name": "萌娘百科",
        "url": "https://zh.moegirl.org.cn/Mainpage#/flow",
        "category": "all",
        "description": "简中ACGN百科，查作品相关、作者推特，查梗等等",
        "icon": "/item_icons/zh_moegirl_org_cn.webp"
      },
      {
        "name": "每日放送 | 番组放送",
        "url": "https://bgmlist.com/",
        "category": "all",
        "description": "在播新番表，番剧可跳转正版、BT网站",
        "icon": "/item_icons/bgmlist_com.webp"
      },
      {
        "name": "YuC's 历年新番查询",
        "url": "https://yuc.wiki/",
        "category": "all",
        "description": "有C整理的新番表",
        "icon": "/item_icons/yuc_wiki.webp"
      },
      {
        "name": "AniDB",
        "url": "https://anidb.net/",
        "category": "评分排行",
        "description": "英文二次元评分WIKI站",
        "icon": "/item_icons/anidb_net.webp"
      },
      {
        "name": "MyAnimeList",
        "url": "https://myanimelist.net/",
        "category": "评分排行",
        "description": "欧美动漫评分网站",
        "icon": "/item_icons/myanimelist_net.webp"
      },
      {
        "name": "Anikore",
        "url": "https://www.anikore.jp/",
        "category": "评分排行",
        "description": "日本动漫评分网站",
        "icon": "/item_icons/www_anikore_jp.webp"
      },
      {
        "name": "面包动画工坊",
        "url": "https://anime.bakery.moe/",
        "category": "番剧搜索",
        "description": "输入番名，检索喜欢看某番剧的人也喜欢看什么",
        "icon": "/item_icons/anime_bakery_moe.webp"
      },
      {
        "name": "寻找类似电影",
        "url": "https://leisidianying.com/",
        "category": "番剧搜索",
        "description": "输入电影名，检索同分类下的电影",
        "icon": "/item_icons/leisidianying_com.webp"
      },
      {
        "name": "Bangumi Research",
        "url": "https://chii.ai/",
        "category": "番剧搜索",
        "description": "bangumi多标签搜索，可以用来找喜欢的类型的番",
        "icon": "/item_icons/chii_ai.webp"
      }
    ]
  },
    "news": {
    "title": "资讯文章",
    "categories": [
      "全部",
      "资讯",
      "图片",
      "情报"],
    "sites": [
      {
        "name": "煎蛋-无聊图",
        "url": "https://jandan.net/pic",
        "category": "图片",
        "description": "每日趣图，实时更新网络热门搞笑图片",
        "icon": "/item_icons/jandan.net.webp"
      },
      {
        "name": "资讯｜机核",
        "url": "https://www.gcores.com/news",
        "category": "资讯",
        "description": "二次元资讯",
        "icon": "/item_icons/www.gcores.com.svg"
      },
      {
        "name": "AcFun-动漫杂谈",
        "url": "https://www.acfun.cn/v/as13",
        "category": "资讯",
        "description": "新闻资讯杂谈",
        "icon": "/item_icons/www.acfun.cn.webp"
      },
      {
        "name": "动漫星空",
        "url": "https://acg.gamersky.com/",
        "category": "资讯",
        "description": "声优、日本动画、国产动画最新资讯",
        "icon": "/item_icons/acg.gamersky.com.webp"
      },
      {
        "name": "摸摸鱼热榜",
        "url": "https://momoyu.cc/",
        "category": "资讯",
        "description": "聚合新闻资讯",
        "icon": "/item_icons/momoyu.cc.webp"
      },
      {
        "name": "SUGOILITE-X",
        "url": "https://x.com/SUGOILITE",
        "category": "情报",
        "description": "推特，最新动画情报速递",
        "icon": "/item_icons/SUGOILITE.webp"
      },
      {
        "name": "続編情報告知-X",
        "url": "https://x.com/zokuhenkokuti",
        "category": "情报",
        "description": "推特，动画化、续作情报速递",
        "icon": "/item_icons/zokuhenkokuti.webp"
      },
      {
        "name": "我不是盐神",
        "url": "https://onehu.xyz/categories/",
        "category": "",
        "description": "知乎盐选文章",
        "icon": "/item_icons/onehu.xyz.webp"
      },
      {
        "name": "pixivision",
        "url": "https://www.pixivision.net/zh/",
        "category": "图片",
        "description": "精选插画佳作或最新话题作品",
        "icon": "/item_icons/www.pixivision.net.webp"
      },
    ]
  },
  "pc": {
    "title": "PC好用软件",
    "categories": [
      "全部",
      "弹幕追番",
      "下载器",
      "工具"
    ],
    "sites": [
      {
        "name": "次元城动漫APP",
        "url": "https://www.cycity.pro/",
        "category": "弹幕追番",
        "description": "高清在线看番，有弹幕",
        "icon": "/item_icons/www_cycity_pro.webp"
      },
      {
        "name": "Animeko",
        "url": "https://myani.org/",
        "category": "弹幕追番",
        "description": "一站式在线弹幕追番平台；多平台、在线追番+字幕组种子下载，同步bangumi",
        "icon": "/item_icons/myani_org.webp"
      },
      {
        "name": "Kazumi",
        "url": "https://github.com/Predidit/Kazumi/releases",
        "category": "弹幕追番",
        "description": "多平台、基于自定义规则的番剧采集APP，支持在线观看、弹幕、实时超分辨率。",
        "icon": "/item_icons/kazumi.webp"
      },
      {
        "name": "Follow",
        "url": "https://follow.is/",
        "category": "工具",
        "description": "订阅各种网站，动态内容，rss神器",
        "icon": "/item_icons/follow_is.webp"
      },
      {
        "name": "漫画柜批量下载器",
        "url": "https://github.com/lanyeeee/manhuagui-downloader/releases",
        "category": "下载器",
        "description": "批量下载，需要代理，作者主页还有拷贝漫画下载器",
        "icon": "/item_icons/github_com.webp"
      },
      {
        "name": "禁漫批量下载器",
        "url": "https://github.com/lanyeeee/jmcomic-downloader/releases/",
        "category": "下载器",
        "description": "批量下载，作者主页还有哔咔下载器",
        "icon": "/item_icons/github_com.webp"
      },
      {
        "name": "弹弹play",
        "url": "https://www.dandanplay.com/",
        "category": "弹幕追番",
        "description": "追番-全功能“本地视频+弹幕”播放器",
        "icon": "/item_icons/www_dandanplay_com.webp"
      },
      {
        "name": "MediaGo",
        "url": "https://downloader.caorushizi.cn/",
        "category": "下载器",
        "description": "视频下载器，嗅探网页视频资源,支持下载B站番剧、批量下载",
        "icon": "/item_icons/downloader_caorushizi_cn.svg"
      },
      {
        "name": "NeatDownload",
        "url": "https://neatdownloadmanager.com/index.php/en/",
        "category": "下载器",
        "description": "免费http多线程下载器，idm替代",
        "icon": "/item_icons/ndm.webp"
      },
      {
        "name": "qBittorrent增强版",
        "url": "https://github.com/c0re100/qBittorrent-Enhanced-Edition/releases",
        "category": "下载器",
        "description": "磁力下载做种软件，反吸血增强",
        "icon": "/item_icons/www_qbittorrent_org.svg"
      },
      {
        "name": "MusicFree",
        "url": "https://github.com/maotoumao/MusicFree?tab=readme-ov-file",
        "category": "all",
        "description": "免费、开源的音乐聚合软件，需要安装插件后才能搜索到歌曲，无法播放尝试更新插件",
        "icon": "/item_icons/github_com.webp"
      },
      {
        "name": "游戏一键汉化工具",
        "url": "https://lion.craft.me/RenpyThief",
        "category": "工具",
        "description": "AI汉化",
        "icon": "/item_icons/lion_craft_me.webp"
      },
      {
        "name": "漫画机器翻译",
        "url": "https://github.com/ogkalu2/comic-translate/blob/main/docs/README_zh-CN.md",
        "category": "工具",
        "description": "漫画机翻",
        "icon": "/item_icons/github_com.webp"
      },
      {
        "name": "BBDown",
        "url": "https://github.com/nilaoda/BBDown/issues/305",
        "category": "下载器",
        "description": "B站视频下载器，番剧下载，批量下载并自动合并音视频，需要用命令行操作",
        "icon": "/item_icons/github_com.webp"
      },
      {
        "name": "磁力搜",
        "url": "https://share.feijipan.com/s/6dHiwZLs",
        "category": "工具",
        "description": "聚合磁力搜索软件",
        "icon": "/item_icons/yiyun_lanzout_com.webp"
      }
    ]
  },
  "apps": {
    "title": "ACGN热门APP",
    "categories": [
      "全部",
      "追番",
      "漫画",
      "小说",
      "美图",
      "本子",
    ],
    "sites": [

      {
        "name": "萌番",
        "url": "https://www.moefun.net/",
        "category": "追番",
        "description": "有开屏广告，安卓、ios双端免费高清，支持视频下载",
        "icon": "/item_icons/www_moefun_net.webp"
      },
      {
        "name": "鸭梨鸭梨",
        "url": "https://ylyl.me/",
        "category": "追番",
        "description": "仅开屏广告，支持视频下载，安卓ios都有",
        "icon": "/item_icons/ylyl_me.webp"
      },
      {
        "name": "拷貝漫畫",
        "url": "https://www.mangacopy.com/download",
        "category": "漫画",
        "description": "拷贝漫画官网，比较全的日漫",
        "icon": "/item_icons/www_mangacopy_com.webp"
      },
      {
        "name": "动漫APP去广告",
        "url": "https://www.yxzhi.com/?post_type=post&s=%E5%8A%A8%E6%BC%AB",
        "category": "追番",
        "description": "一些去广告的追番app",
        "icon": "/item_icons/www_yxzhi_com.webp"
      },
      {
        "name": "venera",
        "url": "https://github.com/venera-app/venera/releases",
        "category": "漫画",
        "description": "多源漫画，可添加拷贝漫画/看漫画/漫蛙等源，漫画源列表可能需要代理",
        "icon": "/item_icons/venera.webp"
      },
      {
        "name": "异次元漫画",
        "url": "https://www.yckceo.com/yiciyuan",
        "category": "漫画",
        "description": "多源漫画，导入源即用，源可频道或源仓库获取",
        "icon": "/item_icons/yiciyuan.webp"
      },
      {
        "name": "轻小说文库",
        "url": "https://wenku8.mewx.org/",
        "category": "小说",
        "description": "文库8的轻小说APP",
        "icon": "/item_icons/wenku8_mewx_org.webp"
      },
      {
        "name": "轻之国度",
        "url": "https://wwqp.lanzouw.com/lkapp",
        "category": "小说",
        "description": "轻之国度app",
        "icon": "/item_icons/www_lightnovel_us.webp"
      },
      {
        "name": "阅读",
        "url": "https://www.yckceo.com/yuedu/index/index.html",
        "category": "小说",
        "description": "网文神器，网站提供导入书源合集以及APP，导入即可",
        "icon": "/item_icons/www_yckceo_com.webp"
      },
      {
        "name": "Z-Library",
        "url": "https://z-library.sk/z-access#android_app_tab",
        "category": "小说",
        "description": "海量电子书下载，需代理",
        "icon": "/item_icons/zlibrary.webp"
      },
      {
        "name": "Shaft-P站免梯",
        "url": "https://github.com/CeuiLiSA/Pixiv-Shaft",
        "category": "美图",
        "description": "第三方pixiv直连,找插画，美图，小说",
        "icon": "/item_icons/shaft.webp"
      },
      {
        "name": "Pixez-P站免梯",
        "url": "https://github.com/Notsfsssf/pixez-flutter",
        "category": "美图",
        "description": "第三方pixiv直连,可识图,找插画，美图，小说",
        "icon": "/item_icons/pixez.webp"
      },
      {
        "name": "酷狗概念版",
        "url": "https://download.kugou.com/",
        "category": "",
        "description": "安卓/ios,每日听歌领1天vip",
        "icon": "/item_icons/download.kugou.com.webp"
      },
      {
        "name": "搜图神器",
        "url": "http://download.soutushenqi.com/",
        "category": "美图",
        "description": "多图源聚合、识图，简单操作找壁纸头像美图",
        "icon": "/item_icons/download_soutushenqi_com.webp"
      },
      {
        "name": "Han1meViewer",
        "url": "https://github.com/Mioxiya/Han1meViewer/releases",
        "category": "追番",
        "description": "新作者接手，🔞han1me免翻，设置-网络-开启hosts",
        "icon": "/item_icons/han1me.webp"
      },
      {
        "name": "Yuro | ASMR.ONE",
        "url": "https://github.com/asmroneapp/Yuro/releases",
        "category": "",
        "description": "🔞需代理，第三方ASMR.ONE客户端，拥有稳定的后台播放、简洁的UI、智能缓存机制。",
        "icon": "/item_icons/yuro.webp"
      },
      {
        "name": "Ehviewer-E站",
        "url": "https://github.com/xiaojieonly/Ehviewer_CN_SXJ",
        "category": "本子",
        "description": "🔞，本子，可能要开代理",
        "icon": "/item_icons/eh.webp"
      },
     {
        "name": "哔咔漫画",
        "url": "https://www.picacomic.com/",
        "category": "本子",
        "description": "🔞，本子，官网需要开代理",
        "icon": "/item_icons/www_picacomic_com.webp"
      },
      {
        "name": "禁漫天堂",
        "url": "https://jmcomicgo.me/",
        "category": "本子",
        "description": "🔞，本子，需要开代理",
        "icon": "/item_icons/jmcomicgo_me.webp"
      },


    ]
  },

  "software": {
    "title": "绿色软件下载",
    "categories": ["全部","免登录"],
    "sites": [
      {
        "name": "Puresys",
        "url": "https://www.puresys.net/",
        "category": "免登录",
        "description": "纯净系统-绿色软件下载，不需登录",
        "icon": "/item_icons/www.puresys.net.webp"
      },  
      {
        "name": "果核剥壳",
        "url": "https://www.ghxi.com/",
        "category": "免登录",
        "description": "绿色软件分享，分享优质软件应用，高速下载需登录",
        "icon": "/item_icons/www.ghxi.com.webp"
      },
      {
        "name": "4分贝分享网",
        "url": "https://4fb.cn/",
        "category": "免登录",
        "description": "软件、影视分享，网盘下载",
        "icon": "/item_icons/4fb.cn.webp"
      },
      {
        "name": "乐于分享网",
        "url": "https://fffxx.com/",
        "category": "all",
        "description": "软件、网站分享，需登录/评论",
        "icon": "/item_icons/fffxx.com.webp"
      },
      {
        "name": "APKPure",
        "url": "https://apkpure.com/cn/",
        "category": "all",
        "description": "谷歌Play替代，安卓端，免费在线APK下载器",
        "icon": "/item_icons/apkpure.com.webp"
      },
      {
        "name": "好料空间",
        "url": "https://www.h6room.com/",
        "category": "all",
        "description": "系统-软件下载，需登录/会员",
        "icon": "/item_icons/www.h6room.com.webp"
      },
      {
        "name": "好软猫",
        "url": "https://www.haoruanmao.com/",
        "category": "资源分享",
        "description": "资源、福利分享，需登录",
        "icon": "/item_icons/www_haoruanmao_com.webp"
      }

    ]
  },
  "forum": {
    "title": "绅士论坛、社区",
    "sites": [
      {
        "name": "萌幻之乡",
        "url": "https://www.mhh1.com/",
        "category": "全部",
        "description": "绅士社区，已被墙",
        "icon": "/item_icons/www.moe-acg.com.webp"
      },
      {
        "name": "ACGDB",
        "url": "https://acgdb.de/",
        "category": "全部",
        "description": "绅士网盘资源",
        "icon": "/item_icons/acgdb.de.webp"
      },
      {
        "name": "北+",
        "url": "https://north-plus.net/",
        "category": "全部",
        "description": "丰富资源的绅士交流地，不定时开放注册",
        "icon": "/item_icons/north-plus.net.webp"
      },
      {
        "name": "sukebei",
        "url": "https://sukebei.nyaa.si/",
        "category": "全部",
        "description": "BT种子站,nyaa里站，已被墙",
        "icon": "/item_icons/nyaa_si.webp"
      },
      {
        "name": "琉璃神社",
        "url": "https://hacg.me/",
        "category": "全部",
        "description": "绅士社区，貌似已被墙",
        "icon": "/item_icons/hacg_me.webp"
      },

      {
        "name": "绅士仓库",
        "url": "https://cangku.moe",
        "category": "全部",
        "description": "二次元绅士社区，不定期开放注册",
        "icon": "/item_icons/cangku.moe.webp"
      },
      {
        "name": "芯幻",
        "url": "https://xhacg.cc/",
        "category": "全部",
        "description": "一个ACG小圈子，绅士游戏分享",
        "icon": "/item_icons/xhcya.com.webp"
      }
    ]
  },
  "more": {
    "title": "更多资源",
    "categories": [
      "全部",
      "资源分享",
      "工具"
    ],
    "sites": [
      {
        "name": "FMHY",
        "url": "https://fmhy.net/",
        "category": "资源分享",
        "description": "老外的书签大全，汇聚各种网站，工具等等",
        "icon": "/item_icons/fmhy_net.webp"
      },
      {
        "name": "Similarsites",
        "url": "https://www.similarsites.com/",
        "category": "工具",
        "description": "相似网站寻找，输入域名匹配相似网站",
        "icon": "/item_icons/www.similarsites.com.webp"
      },
      {
        "name": "源仓库：阅读/异次元漫画",
        "url": "https://www.yckceo.com/",
        "category": "资源分享",
        "description": "书源，漫画源，TV源",
        "icon": "/item_icons/www_yckceo_com.webp"
      },
      {
        "name": "Temp Mail-临时邮件",
        "url": "https://mail.tm/zh/",
        "category": "工具",
        "description": "临时邮件保护您的个人电子邮件地址免受垃圾邮件、机器人、网络钓鱼和其他在线滥用的侵害。",
        "icon": "/item_icons/mail.tm.webp"
      },
      {
        "name": "ipdata",
        "url": "https://ipdata.co/",
        "category": "工具",
        "description": "查找任何 IP 地址的位置和威胁概况，以本地化您的网站内容、分析日志、丰富表单、定位广告、强制遵守 GDPR、执行重定向、阻止国家/地区、检测 VPN 等。",
        "icon": "/item_icons/ipdata.co.webp"
      },
      {
        "name": "Tachiyomi漫画插件下载",
        "url": "https://keiyoushi.github.io/extensions/",
        "category": "工具",
        "description": "漫画源",
        "icon": "/item_icons/keiyoushi_github_io.webp"
      },
      {
        "name": "网页工具",
        "url": "https://iui.su/1492/",
        "category": "工具",
        "description": "齐全的在线工具",
        "icon": "/item_icons/iui_su.webp"
      },
      {
        "name": "优质浏览器扩展",
        "url": "https://www.runningcheese.com/extensions/",
        "category": "工具",
        "description": "扩展插件all",
        "icon": "/item_icons/www_runningcheese_com.webp"
      },
      {
        "name": "常用油猴脚本",
        "url": "https://www.runningcheese.com/userscripts",
        "category": "工具",
        "description": "常用油猴脚本all",
        "icon": "/item_icons/www_runningcheese_com.webp"
      }
    ]
  },
  "FriendLink": {
    "title": "友链",
    "categories": [],
    "sites": [
      {
        "name": "ACG导航",
        "url": "https://www.acgdhz.com/",
        "category": "all",
        "description": "ACG导航",
        "icon": "/item_icons/www_ooacg_com.webp"
      }
    ]
  }
};